<template>
  <svg :style="style" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon_shaixuanzige">
      <rect x="0.666016" width="24" height="24" rx="4" fill="white" />
      <path id="Subtract" fill-rule="evenodd" clip-rule="evenodd"
        d="M16.8182 5.10088C16.6481 4.96704 16.4398 4.89452 16.2256 4.89453H5.972C5.43411 4.89453 4.99805 5.3421 4.99805 5.8942L4.99823 5.9142C5.00241 6.12785 5.07317 6.33449 5.2001 6.50378L9.3042 11.9783V16.7906C9.3042 17.3072 9.58147 17.7818 10.0255 18.0251L11.835 19.0169C12.1957 19.2146 12.6441 19.0747 12.8367 18.7046L12.8455 18.6871C12.897 18.5815 12.9239 18.4649 12.9239 18.3467V11.9569L16.9985 6.50243C17.3258 6.06431 17.2451 5.43678 16.8182 5.10088ZM9.41433 8.26275L10.6439 9.84895C10.7112 9.93574 10.7393 10.0466 10.7215 10.155L10.6298 10.7115C10.5754 11.0418 10.1605 11.1588 9.94161 10.9055L8.61852 9.37504C8.53003 9.27267 8.50013 9.13211 8.53929 9.00259L8.72443 8.39035C8.81725 8.08343 9.21788 8.00933 9.41433 8.26275Z"
        fill="#376EFF" />
      <g id="Vector">
        <path
          d="M20.0001 16.7004C20.0001 16.4133 19.7734 16.1806 19.4937 16.1806H14.6627L14.6507 16.1807C14.3766 16.1872 14.1562 16.4174 14.1562 16.7004C14.1562 16.9875 14.383 17.2202 14.6627 17.2202H19.4937L19.5056 17.2201C19.7798 17.2136 20.0001 16.9834 20.0001 16.7004Z"
          fill="#FE553E" />
        <path
          d="M20.0001 13.471C20.0001 13.1839 19.7734 12.9512 19.4937 12.9512H14.6627L14.6507 12.9513C14.3766 12.9578 14.1562 13.188 14.1562 13.471C14.1562 13.7581 14.383 13.9908 14.6627 13.9908H19.4937L19.5056 13.9907C19.7798 13.9842 20.0001 13.754 20.0001 13.471Z"
          fill="#FE553E" />
        <path
          d="M20.0001 16.7004C20.0001 16.4133 19.7734 16.1806 19.4937 16.1806H14.6627L14.6507 16.1807C14.3766 16.1872 14.1562 16.4174 14.1562 16.7004C14.1562 16.9875 14.383 17.2202 14.6627 17.2202H19.4937L19.5056 17.2201C19.7798 17.2136 20.0001 16.9834 20.0001 16.7004Z"
          stroke="#FE553E" stroke-width="0.315824" />
        <path
          d="M20.0001 13.471C20.0001 13.1839 19.7734 12.9512 19.4937 12.9512H14.6627L14.6507 12.9513C14.3766 12.9578 14.1562 13.188 14.1562 13.471C14.1562 13.7581 14.383 13.9908 14.6627 13.9908H19.4937L19.5056 13.9907C19.7798 13.9842 20.0001 13.754 20.0001 13.471Z"
          stroke="#FE553E" stroke-width="0.315824" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'filter-qualifications',
  props: {
    fontSize: {
      type: String,
      default: '24px'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        'font-size': this.fontSize
      }
    }
  }
}
</script>